import { defineComponent as _defineComponent } from 'vue'
import { UpgradePlanDialogProps, ProductType, FeatureTypes } from '@/components/Billing/billing-types';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
// @ts-ignore
import UpgradePlanDialogContent from '@/components/dialogs/UpgradePlanDialog/UpgradePlanDialogContent.vue';
// @ts-ignore
import UpgradePlanDialogHeader from '@/components/dialogs/UpgradePlanDialog/UpgradePlanDialogHeader.vue';

interface Props extends UpgradePlanDialogProps {
	dialogPromiseHandlers: { resolve: () => void; reject: () => void };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradePlanDialog',
  props: {
    planId: null,
    productId: null,
    featureId: null,
    upgradeNeededExplanation: { default: 'Some actions are not included in your plan' },
    dialogPromiseHandlers: null
  },
  setup(__props: any) {

const props: Props = __props as { planId: string, productId: ProductType, featureId: FeatureTypes, upgradeNeededExplanation: string, dialogPromiseHandlers: { resolve: () => void; reject: () => void } }



const close = () => {
	props.dialogPromiseHandlers.resolve();
	AppDialogManagerService.closeCurrentDialog();
};

return { __sfc: true,props, close, AppDialog, UpgradePlanDialogContent, UpgradePlanDialogHeader }
}

})